import {DateTime} from "@/modules/models";
import {arrEquality, nvl} from "@/modules/utils";

export enum DateMode {
    single,
    fromTo,
    all
}

export default class RegistrationsPageRouteParams {
    from: DateTime | null;
    to: DateTime | null;
    dateMode: DateMode;
    filterLocationIds: number[] = [];
    filterOrgnums: number[] = [];
    page: number;
    ordering: number;
    filterUserGuids: string[] = [];


    constructor(from: DateTime | null, to: DateTime | null, dateMode: DateMode, filterLocationIds: number[], filterOrgNums: number[], page: number, ordering: number, filterUserGuids: string[]) {
        if(dateMode != DateMode.all) {
            this.from = nvl(from, DateTime.now().toMidnight());
            this.to = nvl(to, (this.from as DateTime).nextDay());
        } else {
            this.from = from;
            this.to = to;
        }
        this.dateMode = dateMode;
        this.filterLocationIds = filterLocationIds;
        this.filterOrgnums = filterOrgNums;
        this.page = page;
        this.ordering = ordering;
        this.filterUserGuids = filterUserGuids;
    }

    clone() {
        return new RegistrationsPageRouteParams(this.from, this.to, this.dateMode, [...this.filterLocationIds], [...this.filterOrgnums], this.page, this.ordering, [...this.filterUserGuids]);
    }

    withFrom(from: DateTime | null) {
        const ret = this.clone();
        ret.from = from;
        if(this.dateMode == DateMode.single && ret.from != null) {
            ret.to = ret.from.nextDay();
        }
        return ret;
    }
    withTo(to: DateTime | null) {
        const ret = this.clone();
        ret.to = to;
        return ret;
    }
    withFilterLocationIds(lids: number[]) {
        const ret = this.clone();
        ret.filterLocationIds = lids;
        return ret;
    }
    plusFilterLocationId(id: number) {
        const r = this.clone();
        r.filterLocationIds = [...r.filterLocationIds, id];
        return r;
    }
    minusFilterLocationId(id: number) {
        const r = this.clone();
        r.filterLocationIds = r.filterLocationIds.filter(r => r != id);
        return r;
    }
    plusFilterOrgNum(n: number) {
        const ret = this.clone();
        ret.filterOrgnums = [...ret.filterOrgnums, n];
        return ret;
    }
    minusFilterOrgNum(n: number) {
        const ret = this.clone();
        ret.filterOrgnums = ret.filterOrgnums.filter(r => r != n);
        return ret;
    }

    withPage(v: number) {
        const ret = this.clone();
        ret.page = v;
        return ret;
    }
    withOrdering(v: number) {
        const r = this.clone();
        r.ordering = v;
        return r;
    }

    routeQuery() {
        const p = {
            dateMode: this.dateMode.toString(),
            filterLocationIds: this.filterLocationIds.join(","),
            filterOrgnums: this.filterOrgnums.join(","),
            page: this.page.toString(),
            ordering: this.ordering.toString(),
            filterUserGuids: this.filterUserGuids.join(","),
        };
        if(this.from != null) {
            p["from"] = this.from.toDayParam();
        }
        if(this.to != null) {
            p["to"] = this.to.toDayParam();
        }
        return p;
    }

    equal(o: RegistrationsPageRouteParams) {
        return ((this.from == null && o.from == null ) || (this.from && this.from.equals(o.from) ))
            && ((this.to == null && o.to == null) || (this.to && this.to.equals(o.to)))
            && this.dateMode == o.dateMode
            && arrEquality(this.filterLocationIds, o.filterLocationIds)
            && arrEquality(this.filterOrgnums, o.filterOrgnums)
            && this.page === o.page
            && this.ordering === o.ordering
            && arrEquality(this.filterUserGuids, o.filterUserGuids)
    }
}